// extracted by mini-css-extract-plugin
export var orderSummary = "_th-0";
export var showMoreLessButton = "_th-1";